angular.module('Itao.HyperionAtlas').provider('communeConfig', function () {
  'use strict';

  var config = {
    userID: null,
    communeID: null,
    published: null,
    showEditOptions: false,
    ajaxTargetPid: 0,
    selectInitialIndicator: false,
    selectInitialIndicatorSet: false,
    selectInitialIndicatorUids: []
  };
  return {
    setConfig: function (configName, value) {
      config[configName] = value;
    },
    $get: function () {
      return config;
    }
  };
});
